import React from 'react';
import PropTypes from 'prop-types';

import './scss/statusTitle.scss';

const StatusTitle = ({ status }) => (
  <div className={ `status-title ${status === 'Connected' ? 'connected' : ''}` }>
    Status: <span>{ status }</span>
  </div>
);

StatusTitle.propTypes = {
  status: PropTypes.string.isRequired,
};

export default StatusTitle;



// WEBPACK FOOTER //
// ./src/components/QbTabs/components/StatusTitle.js